import React from "react";

import { filterMaybeArray } from "@examspark/common";
import {
  useQueryGetUserClassrooms,
  useQuerySearchActivities,
  useQuerySearchUserFavorites,
  useAppContext,
} from "@examspark/common-app";

import Dashboard from "../../components/dashboard/Dashboard";

const DashboardRoute = () => {
  const [state] = useAppContext();

  const { data: classrooms, refetch } = useQueryGetUserClassrooms(
    state.workspaceUser?.id,
    state.user?.id,
    false,
  );

  const { data: activities } = useQuerySearchActivities({
    userId: state.user?.id,
  });

  const { data: favorites } = useQuerySearchUserFavorites(state.user?.id);

  return (
    <Dashboard
      favorites={filterMaybeArray(favorites)}
      activities={activities}
      sections={classrooms}
      recents={[]}
      onCreate={() => refetch()}
    />
  );
};

export default DashboardRoute;
